<template>
  <nav class="navbar">
    <div class="navbar__wrapper">
      <div class="navbar__left-side">
        <div class="navbar__logo">
          <a href="https://ritm3.ru/" target="_blank">
            <r-logo :size="21" />
          </a>
        </div>
        <profiles-menu />
      </div>
      <navbar-router />
      <navbar-actions />
    </div>
  </nav>
</template>

<script>
import navbarRouter from "./components/navbar-router";
import navbarActions from "./components/navbar-actions";
import profilesMenu from "@/components/profiles/profiles-menu";

export default {
  components: {
    profilesMenu,
    navbarRouter,
    navbarActions
  },
  computed: {
    showTitle() {
      return this.$route.name === "situation-centre" ? true : false;
    }
  }
};
</script>

<style lang="scss">
.navbar {
  margin-bottom: 0px;
  border: none;
  border-radius: 0px;
  z-index: 100;
  position: relative;
  border-bottom: 1px solid;
  box-sizing: border-box;
  height: 48px;
  overflow: hidden;
  border-color: var(--dividers_low_contrast) !important;
  background-color: var(--bg_panel_primary) !important;

  &__wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 6px 0;
    height: calc(100% - 12px);
  }

  &__left-side {
    display: flex;
    width: 260px;
    border-right: 1px solid;
    position: relative;
    border-color: var(--dividers_low_contrast) !important;
  }

  &__logo {
    width: 24px;
    height: 24px;
    position: relative;
    padding: 6px 18px;
    margin: auto;
  }

  &__title {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
  }
}
</style>

<i18n>
{
  "ru": {
  },
  "en": {
  }
}
</i18n>
